import { render, staticRenderFns } from "./BaseFormGroupTextarea.vue?vue&type=template&id=a22b0e52"
import script from "./BaseFormGroupTextarea.vue?vue&type=script&lang=js"
export * from "./BaseFormGroupTextarea.vue?vue&type=script&lang=js"
import style0 from "./BaseFormGroupTextarea.vue?vue&type=style&index=0&id=a22b0e52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports